// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deal-filters .checkbox input:checked + .icon-span {\n  background: #0af;\n  border-color: #0af;\n}\n.deal-filters .checkboxes {\n  background: transparent;\n  padding: 7px;\n  border: none;\n}\n.deal-filters .checkboxes.disabled label {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.deal-filters .checkboxes.disabled .checkbox input:checked + .icon-span {\n  background: #4e5a6a;\n  border-color: #4e5a6a;\n}\n", ""]);
// Exports
module.exports = exports;
